<template>
  <div class="password-rules">
    <p>
      <font-awesome-icon v-if="lengthValid" icon="check" color="green" />
      <font-awesome-icon v-else icon="times" color="red" />
      &nbsp;
      Contains at least eight characters
    </p>
    <p>
      <font-awesome-icon v-if="upperCharValid" icon="check" color="green" />
      <font-awesome-icon v-else icon="times" color="red" />
      &nbsp;
      Contains at least one upper case character
    </p>
    <p>
      <font-awesome-icon v-if="numberValid" icon="check" color="green" />
      <font-awesome-icon v-else icon="times" color="red" />
      &nbsp;
      Contains at least one number
    </p>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { validatePasswordLength, validatePasswordUpperChar, validatePasswordNumber } from '@/helpers/validate-password';

export default Vue.extend({
  name: "PasswordRules",
  props: {
    password: String
  },
  computed: {
    lengthValid() {
      return validatePasswordLength(this.password);
    },
    upperCharValid() {
      return validatePasswordUpperChar(this.password);
    },
    numberValid() {
      return validatePasswordNumber(this.password);
    }
  }
});
</script>